import React, { useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import useKeypress from 'react-use-keypress'
import Header from '../Header/Header'
import Aside from '../Aside/Aside'

import './Option.scss'
const jezikItems = [
    {
        id: 1,
        name: 'Jezik korisničkog sučelja',
        value: 'Hrvatski',
        description: 'Odaberi jezik korisničkog sučelja.',
        subitems: [
            { id: 1, name: 'Hrvatski' },
            { id: 2, name: 'Engleski' }
        ]
    },
    {
        id: 2,
        name: 'Prvi jezik audio zapisa',
        value: 'Hrvatski',
        subitems: [
            { id: 1, name: 'Hrvatski' },
            { id: 2, name: 'Engleski' },
            { id: 3, name: 'Srpski' },
            { id: 4, name: 'Bosanski' },
            { id: 5, name: 'Njemački' },
            { id: 6, name: 'Francuski' },
            { id: 7, name: 'Španjolski' },
            { id: 8, name: 'Talijanski' },
            { id: 9, name: 'Turski' },
            { id: 10, name: 'Slovenski' },
            { id: 11, name: 'Slovački' },
            { id: 12, name: 'Mađarski' }
        ]
    },
    {
        id: 3,
        name: 'Drugi jezik audio zapisa',
        value: 'Engleski',
        subitems: [
            { id: 1, name: 'Hrvatski' },
            { id: 2, name: 'Engleski' },
            { id: 3, name: 'Srpski' },
            { id: 4, name: 'Bosanski' },
            { id: 5, name: 'Njemački' },
            { id: 6, name: 'Francuski' },
            { id: 7, name: 'Španjolski' },
            { id: 8, name: 'Talijanski' },
            { id: 9, name: 'Turski' },
            { id: 10, name: 'Slovenski' },
            { id: 11, name: 'Slovački' },
            { id: 12, name: 'Mađarski' }
        ]
    },
    {
        id: 4,
        name: 'Prvi jezik podnaslova',
        value: 'Hrvatski',
        subitems: [
            { id: 1, name: 'Hrvatski' },
            { id: 2, name: 'Engleski' },
            { id: 3, name: 'Srpski' },
            { id: 4, name: 'Bosanski' },
            { id: 5, name: 'Njemački' },
            { id: 6, name: 'Francuski' },
            { id: 7, name: 'Španjolski' },
            { id: 8, name: 'Talijanski' },
            { id: 9, name: 'Turski' },
            { id: 10, name: 'Slovenski' },
            { id: 11, name: 'Slovački' },
            { id: 12, name: 'Bez podnaslova' }
        ]
    },
    {
        id: 5,
        name: 'Drugi jezik podnaslova',
        value: 'Bez podnaslova',
        subitems: [
            { id: 1, name: 'Hrvatski' },
            { id: 2, name: 'Engleski' },
            { id: 3, name: 'Srpski' },
            { id: 4, name: 'Bosanski' },
            { id: 5, name: 'Njemački' },
            { id: 6, name: 'Francuski' },
            { id: 7, name: 'Španjolski' },
            { id: 8, name: 'Talijanski' },
            { id: 9, name: 'Turski' },
            { id: 10, name: 'Slovenski' },
            { id: 11, name: 'Slovački' },
            { id: 12, name: 'Bez podnaslova' }
        ]
    },
    { id: 6, name: 'Ažuriranje postavki jezika', value: '' }
]

const videoAudioItems = [
    {
        id: 1,
        name: 'Rezolucija slike',
        value: 'Automatska',
        subitems: [
            { id: 1, name: 'Automatska' },
            { id: 2, name: '720p 50Hz' },
            { id: 3, name: '1080i 50Hz' },
            { id: 4, name: '1080p 50Hz' },
            { id: 5, name: '3840x2160p 24Hz' },
            { id: 6, name: '3840x2160p 25Hz' },
            { id: 7, name: '3840x2160p 50Hz' },
            { id: 8, name: '4096x2160p 24Hz' }
        ]
    },
    {
        id: 2,
        name: 'Format slike',
        value: 'Pillar Box, 4:3',
        subitems: [
            { id: 1, name: 'Pillar Box, 4:3' },
            { id: 2, name: 'Screen Fit, 16:9' },
            { id: 3, name: 'Zum, 16:9' }
        ]
    },
    { id: 3, name: 'EDID', value: '3840x2160p 50Hz' },
    {
        id: 4,
        name: 'Izlazni format zvuka',
        value: 'Passtrough (Auto)',
        subitems: [
            { id: 1, name: 'Passtrough (Auto)' },
            { id: 2, name: 'Stereo (PCM)' }
        ]
    },
    {
        id: 5,
        name: 'HDMI CEC',
        value: 'Isključeno',
        subitems: [
            { id: 1, name: 'Uključeno' },
            { id: 2, name: 'Isključeno' }
        ]
    },
    {
        id: 6,
        name: 'Kvaliteta zvuka',
        value: 'Standardna',
        subitems: [
            { id: 1, name: 'Standardna' },
            { id: 2, name: 'Dolby' }
        ]
    }
]

const profiliItems = [
    { id: 1, name: 'Uredi profil Obitelj', value: '' },
    { id: 2, name: 'Promijeni PIN', value: '' }
]

const prijamnikItems = [
    { id: 1, name: 'MAC adresa', value: '44:f0:34:2f:da:39' },
    { id: 2, name: 'IP adresa', value: '10.46.24.105' },
    { id: 3, name: 'Neprekidno vrijeme rada', value: '37 minuta' },
    { id: 4, name: 'Provjeri internet vezu', value: '' },
    { id: 5, name: 'Ažuriranje sustava', value: 'Bez ' },
    { id: 6, name: 'Ponovno pokretanje prijamnika', value: '' },
    { id: 7, name: 'Vrati na tvorničke postavke', value: '' }
]

const pretrazivanjeItems = [
    { id: 1, name: 'Pretraživanje kabelskih programa', value: '' },
    { id: 2, name: 'Pretraživanje zemaljskih programa', value: '' }
]

const Option = () => {
    const params = useParams()
    const optionName = params.option
    var items = jezikItems

    const setItems = () => {
        if (params.option === 'Video & Audio') {
            items = videoAudioItems
        }
        if (params.option === 'Profili') {
            items = profiliItems
        }
        if (params.option === 'Moj prijamnik') {
            items = prijamnikItems
        }
        if (params.option === 'Pretraživanje programa') {
            items = pretrazivanjeItems
        }
        if (!!params.suboption) {
            items = items.find(item => item.name === params.suboption).subitems
        }
    }

    setItems()

    const [activeSubItem, setActiveSubItem] = useState(items[0])

    const nextItem = () => {
        if (activeSubItem.id < items.length) {
            return items[activeSubItem.id]
        }
        return items[0]
    }

    const previousItem = () => {
        if (activeSubItem.id > 1) {
            return items[activeSubItem.id - 2]
        }
        return items[items.length - 1]
    }

    useKeypress(['ArrowDown', 'ArrowUp'], event => {
        if (event.key === 'ArrowDown') {
            event.preventDefault()
            setActiveSubItem(nextItem())
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault()
            setActiveSubItem(previousItem())
        }
    })

    return (
        <div className="settings">
            <div className="settings-group">
                <Header settings />
                <div className="settings-list">
                    <h1 className="">{params.suboption ? params.suboption : optionName}</h1>
                    <div className="list-and-description">
                        <div className="list">
                            {items?.map(item => {
                                return !params.suboption && item.subitems ? (
                                    <Link
                                        to={`/settings/${optionName}/${item.name}`}
                                        key={item?.id}
                                        className={`
                                            option-item 
                                            ${item.name === activeSubItem.name ? 'red' : ''}
                                            `}
                                    >
                                        <p>{item?.name}</p>
                                        <p className="option-value">{item?.value}</p>
                                    </Link>
                                ) : (
                                    <div
                                        key={item?.id}
                                        className={`
                                            option-item 
                                            ${item.name === activeSubItem.name ? 'red' : ''}
                                            `}
                                    >
                                        <p>{item?.name}</p>
                                        <p className="option-value">{item?.value}</p>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="description">{activeSubItem.description}</div>
                    </div>
                </div>
            </div>
            <Aside
                backLink={`/settings/${!!params.suboption ? params.option : ''}`}
                okLink={`/settings/${optionName}/${activeSubItem.subitems ? activeSubItem.name : ''}`}
                upLink={() => setActiveSubItem(previousItem())}
                downLink={() => setActiveSubItem(nextItem())}
            />
        </div>
    )
}

export default Option
